import { Box, Stack, Typography } from '@mui/material';
import HeroPanelFrame from './HeroPanelFrame';
import flowerIcon from '../../assets/icons/flor-calidad.png';
import truckIcon from '../../assets/icons/camion-envios.png';

export default function HeroAboutPanel({ config, onClose }) {
  const aboutText = (config.quienes_somos_texto ||
    'At Fresh Exports, we offer fresh, elegant and carefully selected flowers for customers who value quality, presentation and a trusted business partner.')
    .replace(/(?:\r?\n)+(?=(?:Nuestra Historia|Nuestro Compromiso|Calidad Internacional)\s*(?:\r?\n|$))/gi, '\n\n');
  return (
    <HeroPanelFrame titleId="hero-about-title" closeLabel="Close About us" onClose={onClose} scrollable={false} sx={{ pb: 3 }}>
      <Stack spacing={2}>
        <Typography id="hero-about-title" component="h2" sx={{
          fontFamily: 'Georgia, serif', fontSize: { xs: 34, lg: 52 }, lineHeight: 1.12,
          overflowWrap: 'anywhere'
        }}>{config.quienes_somos_titulo || 'From Ecuador to the world.'}</Typography>
        <Typography sx={{ fontSize: { xs: 16, md: 17 }, lineHeight: 1.55, whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>
          {aboutText}
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} sx={{ borderTop: '1px solid rgba(121,91,41,.4)', pt: 1.25 }}>
          {[
            [flowerIcon, 'Selected for quality'],
            [truckIcon, 'Care in every shipment']
          ].map(([icon, label]) => (
            <Stack key={label} direction="row" spacing={1} alignItems="center" sx={{
              flex: 1, minWidth: 0,
              '&:not(:first-of-type)': {
                borderLeft: { sm: '1px solid rgba(121,91,41,.3)' },
                pl: { sm: 1.25 }
              }
            }}>
              <Box component="span" aria-hidden="true" sx={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 40, height: 40, flexShrink: 0, borderRadius: '50%',
                bgcolor: 'rgba(227,208,169,.55)'
              }}>
                <Box component="img" src={icon} alt="" sx={{
                  width: 34, height: 34, objectFit: 'contain', display: 'block'
                }} />
              </Box>
              <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{label}</Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </HeroPanelFrame>
  );
}
